function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloudFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "upload_cloud_full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M11 20H6.5a5.361 5.361 0 0 1-3.887-1.575A5.175 5.175 0 0 1 1 14.575 5.542 5.542 0 0 1 2.175 11.1 5.2 5.2 0 0 1 5.25 9.15 6.958 6.958 0 0 1 12 4a6.753 6.753 0 0 1 4.962 2.037A6.754 6.754 0 0 1 19 11a4.51 4.51 0 0 1 4 4.5 4.48 4.48 0 0 1-4.5 4.5H13v-7.15l1.6 1.55L16 13l-4-4-4 4 1.4 1.4 1.6-1.55z",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudFull);
export default __webpack_public_path__ + "static/media/upload_cloud_full.7082ccb087bad89f8e05deb6b79df2e9.svg";
export { ForwardRef as ReactComponent };